import { SendRequest } from './SendRequest';

export async function GraphQLRequest(query: string, variables?: any) {
  return (
    await SendRequest({
      url: '',
      method: 'POST',
      data: {
        query,
        variables,
      },
    })
  ).data.data;
}
